import React, { ReactNode } from 'react';

import { useScreenSizeDetection } from 'common/hooks';
import { Col } from 'components/styled/Grid';

type TSearchBar = {
  content: ReactNode;
  columnWidth?: number;
};

export const SearchBar = ({ searchBarElements }: { searchBarElements: TSearchBar[] }) => {
  const { isMobile } = useScreenSizeDetection();

  return (
    <>
      {searchBarElements.map((item: TSearchBar, index: number) => (
        <Col padding={isMobile ? '0' : '0 12px'} key={index} columnWidth={item.columnWidth}>
          {item.content}
        </Col>
      ))}
    </>
  );
};
